import { useState } from "react";
import { Button, Typography, Space } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const { Text } = Typography;

const SecretDisplay = ({ merchantData }) => {
  const [visible, setVisible] = useState(false);

  // Get the first secret
  const secret =
    merchantData?.terminalRole?.data?.secrets?.[0] ?? "No Secret Found";

  return (
    <Space>
      <h4>Seceret Key: </h4>
      <Text code>{visible ? secret : "••••••••"}</Text>
      <Button
        icon={visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        onClick={() => setVisible(!visible)}
        size="small"
      />
    </Space>
  );
};

export default SecretDisplay;
